var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgCodepen = function SvgCodepen(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21,
    fill: "#1D252D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.168 9.252a1.5 1.5 0 0 1 1.664 0l13.5 9A1.5 1.5 0 0 1 39 19.5v9c0 .502-.25.97-.668 1.248l-13.5 9a1.5 1.5 0 0 1-1.664 0l-13.5-9A1.5 1.5 0 0 1 9 28.5v-9c0-.502.25-.97.668-1.248l13.5-9ZM12 22.302 14.546 24 12 25.697v-3.394Zm1.204 6.198 9.296 6.197v-5.394l-5.25-3.5-4.046 2.697Zm6.75-4.5L24 26.697 28.046 24 24 21.303 19.954 24Zm5.546-5.303 5.25 3.5 4.046-2.697-9.296-6.197v5.394Zm-3-5.394v5.394l-5.25 3.5-4.046-2.697 9.296-6.197Zm13.5 9L33.454 24 36 25.697v-3.394ZM34.796 28.5l-4.046-2.697-5.25 3.5v5.394l9.296-6.197Z",
    fill: "#fff"
  })));
};

export default SvgCodepen;